import { render, staticRenderFns } from "./DeactivateOtherSupplier.vue?vue&type=template&id=5915bef2&scoped=true"
import script from "./DeactivateOtherSupplier.vue?vue&type=script&lang=js"
export * from "./DeactivateOtherSupplier.vue?vue&type=script&lang=js"
import style0 from "./DeactivateOtherSupplier.vue?vue&type=style&index=0&id=5915bef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915bef2",
  null
  
)

export default component.exports